module.exports = __webpack_public_path__ + "static/media/right_light.e98e0999.svg";